import Api from "./baseApi";
export default {
  searchPriceIncrease: (discount) => {
    let url = "/api/priceIncrease?v=1";
    if (discount.search) url += `&q=${discount.search}`;

    if (discount.state > -1) url += `&state=${discount.state}`;
    return Api.get(url);
  },
  getPriceIncrease: () => Api.get("/api/priceIncrease/"),
  getPriceIncreases: (id) => Api.get(`/api/priceIncrease/${id}`),
  putPriceIncrease: (discount) =>
    Api.put(`/api/priceIncrease/${discount.id}`, discount),
  deletePriceIncrease: (discount) =>
    Api.delete(`/api/priceIncrease/${discount.id}`, discount),
  postPriceIncrease: (discount) => Api.post("/api/priceIncrease/", discount),
};
